import { endOfDay } from "date-fns";

import { OrderWindow, Program } from "../../models";
import { utcDate } from "../../utility/utilityFunctions";

export type OrderWindowStatus = "upcoming" | "open" | "closed";

export function getOrderWindowStatus(
  orderWindow: OrderWindow
): OrderWindowStatus {
  const now = new Date();

  if (utcDate(orderWindow.openDate) > now) return "upcoming";
  if (endOfDay(utcDate(orderWindow.closeDate)) < now) return "closed";
  return "open";
}

export function isOrderWindowActive(orderWindow: OrderWindow) {
  return getOrderWindowStatus(orderWindow) === "open";
}

export function isOrderWindowAssignableToProgram(
  orderWindow: OrderWindow,
  program: Program
) {
  const res = {
    isAssignable: true,
    reason: "",
  };
  if (orderWindow.channel?.id !== program.channel?.id) {
    res.isAssignable = false;
    res.reason = "Conflicting channel visibility";
  }

  return res;
}
